<div>{{ placeholder }}</div>

<div *ngIf="canAdd">
  <button *ifAllScopes="addNeededScopes" mat-flat-button color="primary" (click)="addCallback()">{{ addLabel }}</button>
</div>
